import { Component } from '@angular/core';

@Component({
  selector: 'idp-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'xeeva-sso-home';
    constructor() {
        console.log("angular code")
    }
}
